module.exports = __webpack_public_path__ + "assets/img/3_1368_big.98e6ba89.jpg";